'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import styles from './TemplateStartButton.module.scss';
type TemplateStartButtonProps = {
  onClick: () => void;
  label?: string;
};
export function TemplateStartButton(t0) {
  const $ = _c(6);
  const {
    onClick,
    label
  } = t0;
  const t = useTranslations("intro");
  let t1;
  if ($[0] !== label || $[1] !== t) {
    t1 = label ?? t("sample.startTemplate");
    $[0] = label;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onClick || $[4] !== t1) {
    t2 = <button type="button" onClick={onClick} className={styles.button}>{t1}</button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}